
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.617 10h-2.5a1.25 1.25 0 00-1.25 1.25v3.125a1.25 1.25 0 001.25 1.25h1.25a1.25 1.25 0 001.25-1.25V10zm0 0a7.5 7.5 0 00-7.562-7.5A7.5 7.5 0 002.5 10v4.375a1.25 1.25 0 001.25 1.25H5a1.25 1.25 0 001.25-1.25V11.25A1.25 1.25 0 005 10H2.5","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M17.617 14.375v1.875a2.5 2.5 0 01-2.5 2.5h-4.492","stroke":"#fff","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    